import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FINAL_CTA, BRAND } from "@/lib/constants";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function FinalCTA() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section
      data-testid="final-cta-section"
      className="bg-[#20611B] py-16 md:py-24"
    >
      <div
        ref={ref}
        className={`container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl text-center transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-white tracking-tight mb-4">
          {FINAL_CTA.heading}
        </h2>

        <p className="text-base md:text-lg text-white/80 leading-relaxed mb-8 max-w-2xl mx-auto">
          {FINAL_CTA.subheading}
        </p>

        <div className="space-y-3">
          <Link to={BRAND.signupPath}>
            {/* Stripe checkout will connect here */}
            <Button
              data-testid="final-cta-button"
              className="bg-[#D4A84B] hover:bg-[#B88E3B] text-white font-bold h-14 px-10 rounded-md shadow-lg hover:shadow-xl transition-all active:scale-95 text-base tracking-wide"
            >
              {FINAL_CTA.cta}
            </Button>
          </Link>
          <p className="text-sm text-white/70">{FINAL_CTA.ctaSubtext}</p>
          <p className="text-xs text-white/50">{FINAL_CTA.belowText}</p>
        </div>
      </div>
    </section>
  );
}
